/* global YT */
export const videoPlayers = [];
export const videoIds = [];

document.addEventListener("DOMContentLoaded", () => {
  const iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');

  if (!iframes.length) {
    return;
  }

  iframes.forEach((iframe, index) => {
    const videoUrl = iframe.src;
    const match = videoUrl.match(/(?:youtube\.com\/(?:[^"\s]*[?&]v=|embed\/)|youtu\.be\/)([^"&?/\s]{11})/);

    if (match) {
      const videoId = match[1];
      const videoName = iframe.title || `Video ${index + 1}`;

      videoIds.push({ id: videoId, elementId: `player-${index}`, videoName });

      const playerDiv = document.createElement("div");
      playerDiv.id = `player-${index}`;
      iframe.parentNode.replaceChild(playerDiv, iframe);
    }
  });

  if (!window.YT || !window.YT.Player) {
    const script = document.createElement("script");
    script.src = "https://www.youtube.com/iframe_api";
    script.onload = () => {
      initYouTubePlayers();
    };
    script.onerror = (error) => {
      console.error("Error loading YouTube IFrame API", error);
    };
    document.body.appendChild(script);
  } else {
    initYouTubePlayers();
  }

  function sendToGTM(action, videoName = "", videoId = "") {
    const eventName = `video_${action}`;

    if (window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        video_name: videoName,
        video_id: videoId,
      });
    } else {
      console.warn("⚠️ GTM DataLayer not found.");
    }
  }

  function initYouTubePlayers() {
    if (window.YT && window.YT.Player) {
      if (!videoIds.length) {
        console.error("No valid YouTube videos found. Aborting player creation.");
        return;
      }

      videoIds.forEach(({ id, elementId, videoName }) => {
        try {
          let lastSentPercentage = -1;
          let isMuted = false;
          let isFirstPlay = true;
          let isPaused = false;
          let progressInterval = null;
          const watchedPercentages = [5, 10, 25, 50, 75, 100];

          const player = new YT.Player(elementId, {
            height: "360",
            width: "640",
            videoId: id,
            events: {
              onStateChange: (event) => {
                switch (event.data) {
                  case YT.PlayerState.PLAYING: {
                    const duration = player.getDuration();

                    if (isFirstPlay) {
                      sendToGTM("watch_start", videoName, id);
                      isFirstPlay = false;
                    } else if (isPaused) {
                      sendToGTM("unpause", videoName, id);
                      isPaused = false;
                    }

                    if (!progressInterval) {
                      progressInterval = setInterval(() => {
                        const currentTime = player.getCurrentTime();
                        const watchedPercentage = Math.round((currentTime / duration) * 100);

                        watchedPercentages.forEach((percentage) => {
                          if (watchedPercentage >= percentage && lastSentPercentage < percentage) {
                            sendToGTM(`watch_${percentage}%`, videoName, id);
                            lastSentPercentage = percentage;
                          }
                        });
                      }, 1000);
                    }

                    break;
                  }
                  case YT.PlayerState.PAUSED: {
                    sendToGTM("pause", videoName, id);
                    isPaused = true;
                    break;
                  }
                  case YT.PlayerState.ENDED: {
                    sendToGTM("watch_100%", videoName, id);
                    clearInterval(progressInterval);
                    progressInterval = null;
                    break;
                  }
                  default: {
                    break;
                  }
                }
              },
            },
          });

          videoPlayers.push(player);

          player.addEventListener("onVolumeChange", () => {
            if (player.isMuted() && !isMuted) {
              sendToGTM("mute", videoName, id);
              isMuted = true;
            } else if (!player.isMuted() && isMuted) {
              sendToGTM("unmute", videoName, id);
              isMuted = false;
            }
          });
        } catch (error) {
          console.error(`Error creating YT.Player for ${elementId}:`, error);
        }
      });
    } else {
      console.warn("YouTube API is not ready yet. Retrying in 200ms...");
      setTimeout(initYouTubePlayers, 200);
    }
  }
});
